import { DATA_DEMAND_ENDPOINTS } from "./data-demand-endpoints";

/** Менять при смене формата ответа: сбрасывает и ETag, и готовое тело на диске. */
export const API_RESPONSE_PROTOCOL_VERSION = 1;

/** Тяжёлые ответы API, которые сервер хранит готовыми (см. lib/api-response-cache.ts). */
export const API_RESPONSE_CACHE_KINDS = [
  "orders", "products", "products_lite", "supplies", "attributes", "finances", "performance", "performance_periods", "inventory", "order_model",
  "product_money",
  "action_diary",
] as const;

export type ApiResponseCacheKind = (typeof API_RESPONSE_CACHE_KINDS)[number];

/** Те же URL, что у плана загрузки страницы; второй список строк не заводим. */
export const API_RESPONSE_CACHE_ENDPOINTS: Record<ApiResponseCacheKind, string> = {
  orders: DATA_DEMAND_ENDPOINTS.orders[0],
  products: DATA_DEMAND_ENDPOINTS.productsFull[0],
  products_lite: DATA_DEMAND_ENDPOINTS.productsLite[0],
  supplies: DATA_DEMAND_ENDPOINTS.supplies[0],
  attributes: DATA_DEMAND_ENDPOINTS.attrs[0],
  finances: DATA_DEMAND_ENDPOINTS.finances[0],
  performance: DATA_DEMAND_ENDPOINTS.ads[0],
  performance_periods: DATA_DEMAND_ENDPOINTS.ads[1],
  inventory: DATA_DEMAND_ENDPOINTS.inventory[0],
  order_model: "/api/orders/by-model",
  product_money: DATA_DEMAND_ENDPOINTS.productMoney[0],
  action_diary: DATA_DEMAND_ENDPOINTS.actionDiary[0],
};
